import React from 'react';

const URL_SPLIT_REGEX = /((?:https?:\/\/|www\.)\S+)/gi;
const URL_TEST_REGEX = /^(?:https?:\/\/|www\.)/i;
// Strip trailing punctuation that's almost always sentence punctuation, not
// part of the URL ("check this out: https://x.com." shouldn't link the dot).
const TRAILING_PUNCTUATION_REGEX = /[.,!?:;'")\]}]+$/;

/** Turns any http(s):// or www. links in plain text into clickable anchors. */
export const linkifyText = (text) => {
  if (!text) return text;
  return String(text)
    .split(URL_SPLIT_REGEX)
    .map((segment, i) => {
      if (!URL_TEST_REGEX.test(segment)) return segment;

      const trailingMatch = segment.match(TRAILING_PUNCTUATION_REGEX);
      const trailing = trailingMatch ? trailingMatch[0] : '';
      const urlPart = trailing ? segment.slice(0, -trailing.length) : segment;
      const href = urlPart.startsWith('http') ? urlPart : `https://${urlPart}`;

      return (
        <React.Fragment key={i}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'inherit', textDecoration: 'underline', wordBreak: 'break-all' }}
          >
            {urlPart}
          </a>
          {trailing}
        </React.Fragment>
      );
    });
};
